import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["method", "phoneForm", "passwordForm", "emailLinkForm", "phoneHeading", "emailLinkHeading", "generalHeading", "landingSeparator", "errors", "escape", "signup"]

  expand() {
    this.showForm(null)
    this.methodTargets.forEach(method => { method.hidden = false })
    this.escapeTarget.hidden = true
    this.focusFirstControl()
  }

  selectForm(event) {
    this.showForm(event.params.form)
    this.methodTargets.forEach(method => { method.hidden = true })
    this.escapeTarget.hidden = false
    this.focusFirstControl()
  }

  showForm(form) {
    this.phoneFormTarget.hidden = form !== "phone"
    this.passwordFormTarget.hidden = form !== "password"
    this.emailLinkFormTarget.hidden = form !== "email_link"
    this.landingSeparatorTargets.forEach(separator => { separator.hidden = true })
    this.phoneHeadingTargets.forEach(heading => { heading.hidden = form !== "phone" })
    this.emailLinkHeadingTargets.forEach(heading => { heading.hidden = form !== "email_link" })
    this.generalHeadingTargets.forEach(heading => {
      heading.hidden = ["phone", "email_link"].includes(form) || (form === "password" && this.hasErrorsTarget)
    })
    this.errorsTargets.forEach(errors => { errors.hidden = form !== "password" })
    this.signupTarget.hidden = form === "email_link"
  }

  focusFirstControl() {
    const controls = this.element.querySelectorAll('input:not([type="hidden"]), button, a')
    Array.from(controls).find(control => !control.closest("[hidden]"))?.focus()
  }
}
